export default {
    INCLUDE_HASH_MODULE : [
        "/eventcreator/console"
    ],
    PROVIDER_COGNITO: "Cognito",
    PROVIDER_GOFUNDRAISE: "GoFundraise"
}